module.exports = __webpack_public_path__ + "static/media/settingsIcon.f3f4ee0a.svg";